<template>
  <div class="bar">
    <v-container fluid style="padding-top: 70px;">
        <v-img style="height:400px" src="../assets/barDentro.jpg">
            <v-row align="end" class="lightbox white--text pa-2 fill-height">
                <v-col>
                    <v-container>
                        <h1 class="display-2 font-weight-bold">Bar</h1>
                    </v-container>
                </v-col>
            </v-row>
        </v-img>
    </v-container>
    <Card :texts="texts" :cards="cards" />
    <!-- <v-container>
      <h2 class="title text-center">Todos nuestros menus</h2>
      <p class="text-center">Puedes encargarnos tu menu favorito o pedir que te lo llevemos a domicilio</p>
      <v-row>
        <v-col
        v-for="card in cards"
        :key="card.id"
        >
          <v-card
            class="mx-auto"
            max-width="344"
          >
            <v-img
              :src="card.img"
              height="200px"
            ></v-img>

            <v-card-title>
              {{card.title}}
            </v-card-title>

            <v-card-subtitle>
              {{card.text}}
            </v-card-subtitle>

            <v-card-actions>
              <v-btn text>Share</v-btn>

              <v-btn
                color="purple"
                text
              >
                Explore
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn
                icon
                @click="show = !show"
              >
                <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-btn>
            </v-card-actions>

            <v-expand-transition>
              <div v-show="show">
                <v-divider></v-divider>

                <v-card-text>
                  I'm a thing. But, like most politicians, he promised more than he could deliver. You won't have time for sleeping, soldier, not with all the bed making you'll be doing. Then we'll go with that data file! Hey, you add a one and two zeros to that or we walk! You're going to do his laundry? I've got to find a way to escape.
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-card>
        </v-col>
      </v-row>
    </v-container> -->
  </div>
</template>
<script>
import Card from '../components/Card';
export default {
  name: 'Cafe',
  components:{
    Card
  },
  data: () => ({
    cards: [
        {
          id: 1,
          img: require("../assets/bar/milanesa-pan.jpeg"),
          title: 'Milanesa al pan',
          text: 'Asado criollo',
        },
        {
          id: 2,
          img: require("../assets/bar/churrasco-plancha.jpg"),
          title: 'Churrasco a la plancha',
          text: 'Churrasco a la plancha',
        },
        {
          id: 3,
          img: require("../assets/bar/lengueta.jpg"),
          title: 'Lengueta',
          text: 'Lengueta',
        },
        {
          id: 4,
          img: require("../assets/bar/medialuna.jpeg"),
          title: 'Medialuna',
          text: 'Medialuna',
        },
        {
          id: 5,
          img: require("../assets/bar/pizza.jpeg"),
          title: 'No se',
          text: 'Pequeño bar que te hará sentir en casa.',
        },
        {
          id: 6,
          img: require("../assets/bar/paella.jpg"),
          title: 'Paella',
          text: 'Pequeño bar que te hará sentir en casa.',
        },
        {
          id: 7,
          img: require("../assets/bar/tortilla.jpg"),
          title: 'Tortilla',
          text: 'Pequeño bar que te hará sentir en casa.',
        },
        {
          id: 8,
          img: require("../assets/bar/milanesa.jpeg"),
          title: 'Milanesa',
          text: 'Milanesa con salsa... y ensalada  ',
        },
        {
          id: 9,
          img: require("../assets/bar/hamburguesa.jpeg"),
          title: 'Hamburguesas caseras',
          text: 'Hamburguesas caseras',
        },
        {
          id: 10,
          img: require("../assets/bar/milanesapapas.jpeg"),
          title: 'Escalopes caseros',
          text: 'Escalopes caseros',
        },
        {
          id: 11,
          img: require("../assets/bar/lengueta.jpeg"),
          title: 'Entraña',
          text: 'Con criolla (trampó) y mayonesa en pan rustico',
        },
        {
          id: 12,
          img: require("../assets/bar/polloplancha.jpg"),
          title: 'Pollo a la plancha',
          text: 'Pollo a la plancha con patatas, ensalada y huevo.',
        },
        {
          id: 13,
          img: require("../assets/bar/bocatas.jpeg"),
          title: 'Bocatas',
          text: 'Bocatas',
        },
        {
          id: 14,
          img: require("../assets/bar/nose.jpeg"),
          title: 'No se',
          text: 'No se',
        },
        {
          id: 15,
          img: require("../assets/bar/bocata.jpeg"),
          title: 'Bocata',
          text: 'Bocata',
        },
    ],
    texts: {
      title: "Todos nuestros menus",
      subtitle: "Puedes encargarnos tu menu favorito o pedir que te lo llevemos a domicilio"
    }
  }),
}
</script>